module.exports = {"350104001":"仓前街道","350104002":"东升街道","350104003":"对湖街道","350104004":"临江街道","350104005":"三叉街街道","350104006":"上渡街道","350104007":"下渡街道","350104008":"金山街道","350104100":"仓山镇","350104101":"城门镇","350104102":"盖山镇","350104103":"建新镇","350104104":"螺洲镇","350104400":"红星农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350104.json
// module id = 1067
// module chunks = 0